"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Auth = void 0;
const axios_1 = __importDefault(require("axios"));
const OneMap_1 = require("../OneMap");
const _1 = require(".");
class Auth extends _1.Service {
    constructor(onemap) {
        super(onemap, 'auth');
    }
    getToken() {
        var _a, _b, _c, _d, _e, _f;
        return __awaiter(this, void 0, void 0, function* () {
            if (!((_a = this.onemap.options) === null || _a === void 0 ? void 0 : _a.credential)) {
                throw new Error('No credential provided.');
            }
            if (!((_c = (_b = this.onemap.options) === null || _b === void 0 ? void 0 : _b.credential) === null || _c === void 0 ? void 0 : _c.email) || !((_e = (_d = this.onemap.options) === null || _d === void 0 ? void 0 : _d.credential) === null || _e === void 0 ? void 0 : _e.password)) {
                throw new Error('Incomplete credential provided.');
            }
            const response = yield (0, axios_1.default)(`${OneMap_1.OneMap.BASE_URL}/privateapi/auth/post/getToken`, {
                proxy: (_f = this.onemap.options) === null || _f === void 0 ? void 0 : _f.proxy,
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                data: this.onemap.options.credential
            });
            return response.data;
        });
    }
}
exports.Auth = Auth;
